import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/modules/shared/components/ui/alert-dialog'
import { DialogFooter } from '@/modules/shared/components/ui/dialog'

interface IModalSelectCompanyComponent {
	isOpen: boolean
	onConfirm: () => void
	onCancel: () => void
}

export function ModalChangeCustomerComponent({
	isOpen,
	onCancel,
	onConfirm,
}: IModalSelectCompanyComponent) {
	const onConfirmChange = () => {
		onConfirm()
	}

	const onCancelChange = () => {
		onCancel()
	}

	return (
		<AlertDialog open={isOpen}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Cliente</AlertDialogTitle>
					<AlertDialogDescription>
						Deseja alterar os dados do cliente?
					</AlertDialogDescription>
				</AlertDialogHeader>

				<DialogFooter>
					<AlertDialogCancel onClick={onCancelChange}>Não</AlertDialogCancel>

					<AlertDialogAction onClick={onConfirmChange}>Sim</AlertDialogAction>
				</DialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
